const KEY = "hs_consent";
export const CONSENT_VERSION = 1;

export function getConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    return c && c.version === CONSENT_VERSION ? c : null;
  } catch {
    return null;
  }
}

export function applyConsent(c) {
  const ph = window.posthog;
  if (!ph || !c) return;
  try {
    if (c.statistics) {
      ph.set_config?.({ persistence: "localStorage+cookie" });
      ph.opt_in_capturing?.();
    } else ph.opt_out_capturing?.();
  } catch {
    /* analytics unavailable */
  }
}

export function saveConsent(prefs) {
  const c = { necessary: true, statistics: !!prefs.statistics, marketing: !!prefs.marketing, version: CONSENT_VERSION, ts: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(c));
  applyConsent(c);
  window.dispatchEvent(new Event("hs-consent-change"));
  return c;
}

export const openCookiePrefs = () => window.dispatchEvent(new Event("hs-open-cookie-prefs"));
